module.exports = __webpack_public_path__ + "static/media/sg6cr0.1c8107df.png";